module.exports = __webpack_public_path__ + "static/img/pro.d092c75c.png";